import { components } from "@certn/legacy-api/generated-schemas/people";

import { OneIdSummaryField } from "./OneIdSummaryField";
import { FieldType } from "../types";

export function OneIDField(
  field: components["schemas"]["OneIDVerificationField"]
): FieldType<components["schemas"]["OneIDVerificationField"]> {
  return {
    field,
    summaryElement: () => <OneIdSummaryField key={field.name} field={field} />,
  };
}
